import { useMemo } from 'react'
import { IDoesFilterPassParams } from 'ag-grid-community'
import { CustomFilterProps, useGridFilter } from 'ag-grid-react'

/**
 * ServerSideUuidFilter は UI を持たず、外部から setModel 経由で filteredIds を受け取る。
 * リアクティブ化では model = string[] | null として扱う。
 * model が null の場合はフィルター非アクティブ、string[] の場合はそれを filteredIds として使う。
 */
export const ServerSideUuidFilter = ({ model }: CustomFilterProps) => {
  // model (string[]) から filteredIds を導出
  const filteredIds = useMemo(
    () => (model ? new Set(model as string[]) : undefined),
    [model]
  )

  useGridFilter({
    doesFilterPass(params: IDoesFilterPassParams) {
      // Don't filter new rows
      if (params.data.added) return true
      if (!filteredIds) return true
      return params.node.id ? filteredIds.has(params.node.id) : false
    },
  })

  return <></>
}
